import { Stack, Typography } from '@mui/material';
import { OrganisationNotificationListItem } from './OrganisationNotificationListItem';
import { TOrganisationNotification } from './type';

export default function OrganisationNotificationList({
  notifications,
  onRemoveNotification,
}: {
  notifications: TOrganisationNotification[];
  onRemoveNotification: (id: string) => void;
}) {
  if (notifications.length < 1) {
    return <Typography>No any active notification.</Typography>;
  }

  return (
    <Stack>
      {notifications.map((notification) => (
        <OrganisationNotificationListItem
          key={notification.id}
          item={notification}
          onRemoveNotification={onRemoveNotification}
        />
      ))}
    </Stack>
  );
}
